import React, { useState } from 'react';
import { Tooltip } from '@material-ui/core';

export interface DamagePhotoMarkerProps {
  pointX: number;
  pointY: number;
  label: string | null;
}

const MARKER_SIZE = 12;

const DamagePhotoMarker: React.FC<DamagePhotoMarkerProps> = ({ pointX, pointY, label }) => {
  const [isHovered, setIsHovered] = useState(false);

  const marker = (
    <span
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{
        position: 'absolute',
        left: `${pointX}%`,
        top: `${pointY}%`,
        width: MARKER_SIZE,
        height: MARKER_SIZE,
        transform: 'translate(-50%, -50%)',
        borderRadius: '50%',
        backgroundColor: '#f83245',
        border: '2px solid #fff',
        boxShadow: '0 0 4px rgba(0, 0, 0, 0.5)',
        opacity: isHovered ? 0 : 1,
        transition: 'opacity 0.15s ease-in-out'
      }}
    />
  );

  return label ? (
    <Tooltip title={label} arrow placement="top">
      {marker}
    </Tooltip>
  ) : (
    marker
  );
};

export default DamagePhotoMarker;
